<template>
  <div class="text-lg font-semibold text-foreground  leading-7">
    <slot />
  </div>
</template>